<template>
  <div id="wrap-projects">

    <loading :active.sync="busy"/>

    <!-- Empty container -->
    <div id="empty-container" v-if="!projects||!sorted_projects.length">
      <div id="empty-title">
        <div>아직 열람 프로젝트가 없습니다</div>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-icon small color="#536BFF">mdi-information</v-icon>
            </div>
          </template>
          <div>열람 프로젝트란 다른 회원이 당신에게 공개한 프로젝트입니다.</div>
          <div>{{ $t("lab.project_info_2") }}</div>
        </v-tooltip>
      </div>
      <div id="empty-subtitle">다른 회원님의 프로젝트 초대를 수락하시면 이 화면에 열람 프로젝트 목록이 나타납니다.</div>
    </div>

    <!-- Container -->
    <div id="header-projects" v-else>
      <div id="title-projects">
        열람 프로젝트
      </div>
      <div id="btns-projects">
        <v-btn text @click="invitation_dialog=true">
          <span>전체 리스트 보기</span>
        </v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn icon color="#c1c3c9">
                <v-icon>mdi-sort-descending</v-icon>
              </v-btn>
            </div>
          </template>
          <v-list dense>
            <v-list-item @click="sort_by=sort_by==2?1:2">
              <v-list-item-icon small>
                <v-icon v-if="sort_by==1" color="#766BFF">mdi-arrow-up</v-icon>
                <v-icon v-if="sort_by==2" color="#766BFF">mdi-arrow-down</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                {{ $t('sorting.title') }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="sort_by=0">
              <v-list-item-icon small>
                <v-icon v-if="sort_by==0" color="#766BFF">mdi-arrow-down</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                {{ $t('sorting.visited_date') }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="sort_by=sort_by==4?3:4">
              <v-list-item-icon small>
                <v-icon v-if="sort_by==3" color="#766BFF">mdi-arrow-up</v-icon>
                <v-icon v-if="sort_by==4" color="#766BFF">mdi-arrow-down</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                {{ $t('sorting.created_date') }}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <div id="container-projects">

      <div class="list-projects" v-if="!!waiting_projects.length">
        
        <div class="list-header">
          <div class="list-title">
            <span>새로 초대된 프로젝트</span>
            <span>[{{ waiting_projects.length }}]</span>
          </div>
        </div>

        <div class="list-cards">
          <v-card class="card new-card" flat v-for="item in waiting_projects" :key="item.proj_id"
            @click="accept_dialog=true;selected_id=item.proj_id">
            <div class="card-header">
              <v-clamp :max-lines="1" class="card-title new-card-title">{{ item.title }}</v-clamp>
            </div>
            <div class="card-meta">
              <div class="author">{{ item.owner.name }}</div>
            </div>
          </v-card>
          <div v-for="i in ph_numbers"
            :key="i" 
            class="card-placeholder">
          </div>
        </div>

      </div>

      <div class="list-projects" v-if="!!watching_projects.length">

        <div class="list-header">
          <div class="list-title">
            <span>열람 중인 프로젝트</span>
            <span>[{{ watching_projects.length }}]</span>
          </div>
        </div>

        <div class="list-cards">
          <v-card class="card" flat v-for="item in watching_projects" :key="item.proj_id"
            @click="getProject(item.proj_id)">
            <div class="card-header">
              <v-clamp :max-lines="1" class="card-title">{{ item.title }}</v-clamp>
            </div>
            <div class="card-meta">
              <div class="author">{{ item.owner.name }}</div>
              <div class="document-wrap">
                <div class="document">{{ $t("lab.document") }} {{ item.num_docs }}</div>
              </div>
            </div>
          </v-card>
          <div v-for="i in ph_numbers"
            :key="i" 
            class="card-placeholder">
          </div>
        </div>

      </div>

    </div>

    <!-- Accept dialog -->

    <template>
      <v-dialog v-model="accept_dialog" width="400px">
        <v-card>
          <v-card-title class="card-title">
            <span>프로젝트를 열람하시겠습니까?</span>
            <v-btn icon @click="accept_dialog=false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text v-if="!!selected_proj">
            <div>"{{ selected_proj.title }}" 프로젝트를 열람하시려면 '열람'을, 열람하지 않고 숨기시려면 '숨김'을 선택하세요.</div>
            <div>화면 오른쪽 상단의 '전체 리스트 보기'에서 언제든 숨김을 해제할 수 있습니다.</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed @click="responseInvitation(selected_proj.proj_id, 0)">
              숨김
            </v-btn>
            <v-btn depressed color="primary" @click="responseInvitation(selected_proj.proj_id, 1)">
              열람
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- Invitation dialog -->
    <template>
      <v-dialog v-model="invitation_dialog" width="400px">
        <v-card>
          <v-card-title class="card-title">
            <span>초대된 프로젝트 리스트</span>
            <v-btn icon @click="invitation_dialog=false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-list>
            <v-list-item v-for="proj in sorted_projects" :key="proj.proj_id">
              <v-list-item-content>
                <v-list-item-title v-text="proj.title"></v-list-item-title>
                <v-list-item-subtitle>{{ proj.owner.name }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <span class="italic" v-if="proj.response==0">대기 상태</span>
                <span class="italic" v-if="proj.response==1&&proj.status==1">열람 상태</span>
                <span class="italic" v-if="proj.response==1&&proj.status==0">숨김 상태</span>
              </v-list-item-action>
              <v-list-item-action>
                <v-btn v-if="proj.response==0" depressed color="primary" small
                  @click="responseInvitation(proj.proj_id, 1)">열람</v-btn>
                <v-btn v-if="proj.response==1&&proj.status==1" depressed small
                  @click="responseInvitation(proj.proj_id, 0)">숨김</v-btn>
                <v-btn v-if="proj.response==1&&proj.status==0" depressed color="primary" small
                  @click="responseInvitation(proj.proj_id, 1)">열람</v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-card-actions>

          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VClamp from 'vue-clamp'
import { sortProjects } from '../../../custom/function.js'

export default {
  metaInfo() {
    return {
      title: "Watching-projects",
    }
  },

  components: {
    VClamp,
  },

  props: {
    ph: {
      required: true,
      type: Number,
    },
  },

  data() {
    return {
      busy: false,
      sort_by: 0,
      sorted_projects: [],
      waiting_projects: [],
      watching_projects: [],
      selected_id: null,

      accept_dialog: false,
      invitation_dialog: false,
    }
  },

  computed: {
    ...mapGetters({
      projects: 'watching/projects',
    }),

    selected_proj() {
      return this.waiting_projects.filter(v => v.proj_id == this.selected_id)[0]
    },

    ph_numbers() {
      return !this.ph ? [] : [...Array(this.ph).keys()]
    },
  },

  watch: {
    sort_by(val) {
      this.sorted_projects = this.sortProjects(this.sorted_projects, this.sort_by) || []
    },

    projects: {
      handler(val) {
        this.getProjects()
      },
    },
  },

  async created() {
    try {
      this.busy = true
      await this.$store.dispatch('watching/getProjects')
    } finally {
      this.busy = false
    }
  },

  methods: {
    sortProjects,

    getProjects() {
      let projs = JSON.parse(JSON.stringify(this.projects))
      this.sorted_projects = this.sortProjects(projs, this.sort_by).filter(v => v.owner.is_valid == 1) || []
      this.waiting_projects = this.sorted_projects.filter(v => v.response == 0)
      this.watching_projects = this.sorted_projects.filter(v => v.response == 1 && v.status == 1)
    },

    getProject(proj_id) {
      this.$router.push({ name: 'watching-project', params: {id: proj_id}})
    },

    async responseInvitation(proj_id, opt) {
      await this.$store.dispatch('watching/responseInvitation', {
        proj_id,
        status: opt,
      })
      this.accept_dialog = false
      this.invitation_dialog = false
    },
  },

}
</script>

<style scoped>

  /* Empty */
  #empty-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 60px);
    width: 100%;
  }

  #empty-title {
    display: flex;
    flex-direction: row;
    justify-content: center;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  #empty-subtitle {
    font-size: 14px;
  }

  /* Header */

  #header-projects {
    padding: 20px 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  #title-projects {
    font-size: 16px;
    font-weight: 600;
    color: #323334;
  }

  #btns-projects {
    display: flex;
    flex-direction: row;
    align-items: center;
  }


  /* Content */

  #container-projects {
    padding: 20px 40px;
  }

  .list-projects {
    border-top: solid 1px #dde2e5;
    padding-bottom: 24px;
  }

  .list-projects:first-child {
    border-top: none;
  }

  .list-header {
    padding-top: 16px;
    width: 100%;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 20px;
    color: rgb(95, 99, 104);
    font-size: 14px;
  }

  .list-cards {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    align-content: stretch;
  }

  .card {
    padding: 20px 12px 20px 20px;
    border-radius: 4px;
    border: solid 1px #dde2e5 !important;
    background-color: #ffffff;
    margin: 10px;
    flex-basis: 252px;
    flex-grow: 1;
  }

  .new-card {
    background-color: rgba(255, 81, 147, 0.1);
    color: #ff5193;
    border: none !important;
  }

  .card:hover {
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
  }

  .card-placeholder {
    flex-basis: 252px;
    flex-grow: 1;
    margin: 10px;
  }

  .card-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .card-title {
    font-size: 14px;
    font-weight: 600;
    color: #323334;
  }

  .card-meta {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .document-wrap {
    margin-left: 4px;
    padding: 4px 10px 3px 11px;
    border-radius: 12px;
    background-color: rgba(83, 107, 255, 0.1);
  }

  .document {
    font-size: 11px;
    font-weight: 500;
    color: #455ffe;
    width: 100%;
  }

  /* Modal */

  .card-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .new-card-title {
    color: #ff5193;
  }

  .italic {
    font-style: italic;
  }
</style>


// WEBPACK FOOTER //
// src/components/spa/lab/Watching-projects.vue